import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { LaunchCard, LaunchCardSkeleton } from "@/components/LaunchCard";

export const UpcomingLaunchesSection = ({ loading, launches }) => (
  <section>
    <div className="flex items-center justify-between mb-4">
      <h2 className="section-title">Upcoming Launches</h2>
      <Link
        to="/launches"
        className="text-sm text-cosmic-blue hover:text-cosmic-blue-glow font-heading font-semibold uppercase tracking-wider flex items-center gap-1"
        style={{ transition: "color 0.2s ease" }}
        data-testid="view-all-launches"
      >
        View All
        <ChevronRight className="w-4 h-4" strokeWidth={1.5} />
      </Link>
    </div>
    <div className="space-y-4">
      {loading ? (
        <>
          <LaunchCardSkeleton />
          <LaunchCardSkeleton />
        </>
      ) : launches?.length > 0 ? (
        launches.map((launch, index) => (
          <div key={launch.id} className="stagger-item" style={{ animationDelay: `${index * 0.1}s` }}>
            <LaunchCard launch={launch} />
          </div>
        ))
      ) : (
        <div className="glass-card p-6 text-center">
          <p className="text-slate-400">No more upcoming launches</p>
        </div>
      )}
    </div>
  </section>
);
